module.exports = __webpack_public_path__ + "static/img/kexinwangzhan.fcb135b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/kexinwangzhan.png
// module id = Uq1x
// module chunks = 1 3 4 5 6 7